export const typeList = [
  {
    type: 'BASP',
    label: 'Ba Penerimaan',
  },
  {
    type: 'CANCELLATION',
    label: 'Alasan pembatalan',
  },
  {
    type: 'ACCIDENT',
    label: 'Kecelakaan',
  },
];

const getTypeLabel = (type) => typeList.find((i) => i.type === type).label || '';

export default {
  button: {
    ADD_OPTION: 'Tambah Pilihan',
    UPLOAD_CSV: 'Upload CSV',
    TEMPLATE_CSV: 'Template CSV',
    STATUS: 'Status data yang diupload',
    ADD: 'Tambah Alasan',
  },
  label: {
    PAGE: 'Pilihan dan Alasan',
    SEARCHING_PLACEHOLDER: 'Cari Pilihan dan Alasan',
    TITLE: 'Database Pilihan dan Alasan',
    CREATE_ENTRY: 'Buat Entri Pilihan dan Alasan',
    EDIT_ENTRY: 'Ubah Entri Pilihan dan Alasan',
    UPLOADED: 'Status data yang telah diunggah',
    REASON_FOR_CANCELLATION: 'Alasan Pembatalan',
    ACCIDENT_DESC: 'Keterangan Kecelakaan',
  },
  headers: {
    ITEM: 'Item',
    TYPE: 'Tipe',
    NEED_CONFIRM: 'Butuh Konfirmasi',
    FREE_TEXT: 'Free Text',
    ACTIVE: 'Aktif',
    CREATED_BY: 'Dibuat Oleh',
    UPLOAD_BY: 'Diunggah Oleh',
    UPLOAD_AT: 'Diunggah Pada',
    DESCRIPTION: 'Deskripsi',
    ROW_DATA: 'Baris Ke',
    STATUS: 'Status Proses',
    SUCCESS: 'Sukses',
    FAILED: 'Gagal',
  },
  typeList,
  getTypeLabel,
  STATUS_TYPE: [
    {
      value: 'BASP,CANCELLATION,ACCIDENT',
      text: 'Semua Tipe',
    },
    {
      value: 'BASP',
      text: 'Ba Penerimaan',
    },
    {
      value: 'CANCELLATION',
      text: 'Alasan pembatalan',
    },
    {
      value: 'ACCIDENT',
      text: 'Kecelakaan',
    },
  ],
};
